"use strict";
import EventEmitter from 'eventemitter2';
import Browser from '../util/browser'

class Video extends EventEmitter{
	constructor($con){
		super();		
		this.$con = $con;
		this.$video;
		this.isPlay = false;
	}

	init(){
		let src = this.$con.data('src');
		let h = '';
		h += '<video preload="metadata" loop preload="auto" width="" height="" poster="" data-setup="{}">';
		h += `<source src="${src}" type="video/mp4">`;
		h += 'Your browser does not support the video tag.';
		h += '</video>';
		this.$con.append(h);
		this.$video = this.$con.find('video');
		this.$video.css({visibility:'hidden'});

		//再生ラグを避ける為一度再生して初期位置に。
		this.canplaythroughHandler = ()=>{
			this.$video[0].removeEventListener('canplaythrough', this.canplaythroughHandler);
			this.$video[0].play();
			setTimeout(()=>{
				this.$video[0].pause();
				this.$video[0].currentTime = 0;
				this.emit('ready');
			}, 700);
		};
		this.$video[0].addEventListener('canplaythrough', this.canplaythroughHandler);
		this.$video[0].load();
		
		Browser.addResizeHandler(this.resize,this);
		this.resize();
	}
	
	replay(){
		this.isPlay = true;
		this.$video[0].currentTime = 0;
		this.$video[0].play();
	}
	
	play(){
		this.isPlay = true;
		this.$video.css({visibility:''});
		this.$video[0].play();
	}
	
	stop(){
		this.isPlay = false;
		this.$video[0].pause();
	}
	
	resize(){
		let w,h,top,left;
		let initW = this.$con.data('width');
		let initH = this.$con.data('height');
		let rate1 = Browser.windowWidth / Browser.windowHeight;
		let rate2 = initW/initH;
		if(rate1 > rate2){
			w = Browser.windowWidth;
			h = initH * Browser.windowWidth/initW;
			top = -(h - Browser.windowHeight)>>1;
			left = 0;
			
		} else {
			w = initW * Browser.windowHeight/initH;
			h = Browser.windowHeight;
			top = 0;
			left = -(w - Browser.windowWidth)>>1;
		}
		w = Math.ceil(w);
		h = Math.ceil(h);
		top = Math.ceil(top);
		left = Math.ceil(left);
		
		//w += 2;
		//h += 2;
		//top -=1;
		//left -=1;
		this.$video.css({width:w,height:h,top:top , left:left});
		//this.$video.css({top:top , left:left});
	}

}

export default Video;


// WEBPACK FOOTER //
// ./js/video/video.js